/* External */
import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

/* Ott-common */
import { Group } from '@dtvgo/group-standing';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import { useIsBrazil } from '../../providers/ConfigProvider';

/* Styles */
import './GroupStanding.scss';

function GroupStanding({
  focused,
  item: group,
}) {
  const { formatMessage } = useIntl();
  const parsedGroup = useMemo(() => ({
    ...group,
    teams: group?.teams?.map((team) => ({
      ...team,
      team: {
        ...team?.team,
        images: Object.values(team?.team?.images),
      },
    })),
  }), [group]);

  const isBrazil = useIsBrazil();

  return (
    <Group
      className={`
          ${isBrazil ? '' : 'dtv-group-standing--color-hispam'}
          dtv-html5-c-group-standing
          dtv-common-c-group-standing
          ${focused ? 'dtv-common-c-group-standing--focused' : ''}
      `}
      group={parsedGroup}
      completedText={formatMessage({ id: 'sports.complete', defaultMessage: 'FINALIZADO' })}
    />
  );
}
GroupStanding.propTypes = {
  focused: PropTypes.bool.isRequired,
  item: PropTypes.shape().isRequired,
};

export default memo(withInteractiveFocusable()(memo(GroupStanding)));
